import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { selectedResourcesByMasterIdSelector } from "../selectedResourcesByMasterIdSelector";
import { isResourceKubernetes } from "../../../../utils/helpers/isResourceKubernetes";
import { ProviderAccessType, ProviderType } from "@/services/cloudchipr.api";

export const selectedResourcesAccountsMetadataSelector =
  createDraftSafeSelector(
    [selectedResourcesByMasterIdSelector],
    (data): Metadata[] | undefined => {
      if (!data) {
        return;
      }

      return data?.reduce((result, resource) => {
        if (!resource) {
          return result;
        }

        const id = isResourceKubernetes(resource)
          ? resource.cluster.id
          : resource.account.id;

        const newItem: Metadata = {
          name: "",
          id: "",
          provider: "aws",
          accessType: "read",
        };

        if (isResourceKubernetes(resource)) {
          newItem.id = resource.cluster.id;
          newItem.provider = resource.cluster.provider;
          newItem.accessType = "read";
          newItem.name = `${resource.cluster.name ?? resource.cluster.provider_id}`;
        } else {
          newItem.id = resource.account.id;
          newItem.provider = resource.account.provider;
          newItem.accessType = resource.account.provider_access_type;
          newItem.name = `${resource.account.provider_account_name ?? resource.account.provider_account_id}`;
        }

        if (!result?.find((item) => item.id === id)) {
          result.push(newItem);
        }
        return result;
      }, [] as Metadata[]);
    },
  );

type Metadata = {
  name: string;
  id: string;
  provider: ProviderType;
  accessType: ProviderAccessType;
};
